import React, { useCallback, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import _ from "underscore";
import { useSearchParams } from "react-router-dom";
import { DayPicker } from "react-day-picker";
import { ptBR } from "react-day-picker/locale";
import { toast } from "react-toastify";
import "react-day-picker/style.css";

import styles from "../finance/finance.module.css";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import { usePdfExport } from "../../../hooks/usePdfExport";
import logoLoginImg from "../../../assets/logo-login.svg";
import Button from "../../../components/button/button";
import ZeroData from "../../../components/zeroData/zeroData";
import FinanceCard from "../../../components/finance/financeCard/financeCard";
import TeacherRegimeQualificationChart from "../../../components/regulatory/teacherRegimeQualificationChart";
import FilterSelect from "../../../components/predictive/filterSelect/filterSelect";
import SavedFiltersModal from "../../../components/filters/savedFiltersModal/savedFiltersModal";
import SaveFilterModal from "../../../components/filters/saveFilterModal/saveFilterModal";

import CalendarIcon from "../../../assets/icons/calendar.svg";
import RegulatoryIcon from "../../../assets/icons/regulatorio-icon.svg";
import BarsFilterIcon from "../../../assets/icons/bars-filter.svg";
import FileExportIcon from "../../../assets/icons/file-export.svg";
import ChartMixedPorcentageIcon from "../../../assets/icons/chart-mixed-porcentage.svg";
import ChartUserCheckIcon from "../../../assets/icons/chart-user-check.svg";
import ChartUserSearchIcon from "../../../assets/icons/chart-user-search.svg";
import ChartMoneyIcon from "../../../assets/icons/chart-money.svg";
import ChartCourseUpIcon from "../../../assets/icons/chart-course-up.svg";
import ChartUserShieldIcon from "../../../assets/icons/chart-user-shield.svg";
import UserIcon from "../../../assets/icons/user.svg";
import CalendarDayIcon from "../../../assets/icons/calendar-day.svg";
import BookIcon from "../../../assets/icons/book.svg";
import DiscIcon from "../../../assets/icons/discipline.svg";
import CourseIcon from "../../../assets/icons/course.svg";
import LocaleIcon from "../../../assets/icons/locale.svg";
import ClassesIcon from "../../../assets/icons/classes.svg";
// users.svg tem fill branco (some no card claro); users-two.svg e a mesma arte em azul
import UsersIcon from "../../../assets/icons/users-two.svg";
import loadingGif from "../../../assets/loading.gif";

import { formatDate, formatDateForApiQuery, addPorcentage } from "../../../utils/formatter";
import useOutsideAlerter from "../../../utils/clickOutside";
import { getDateRange, saveDateRange, saveSharedFilters, getSharedFilters, clearSharedFilters } from "../../../utils/localStorage";
import { useInstitution } from "../../../context/InstitutionContext";
import { useMantenedora } from "../../../context/MantenedoraContext";
import { regulatoryInstitution, regulatoryTeachersByRegime } from "../../../services/regulatory";
import { insightsFilters } from "../../../services/insights";
import { getSavedFilterById } from "../../../services/finance";

const EMPTY_REGULATORY_DATA = {
  activeTeachers: 0,
  ndeMembers: 0,
  averageWeeklyHoursIes: 0,
  averageHigherEducationYears: 0,
  teacherMarketExperience: {
    totalTeachers: 0,
    sumWorkMarketYears: 0,
    knownWorkMarketCount: 0,
    averageYears: 0
  },
  teacherHigherEducationTeaching: {
    totalTeachers: 0,
    sumHigherEducationYears: 0,
    knownHigherEducationCount: 0,
    averageYears: 0
  },
  coordinatorProfile: {
    totalTeachers: 0,
    sumCoordinatorYears: 0,
    knownCoordinatorYearsCount: 0,
    averageCoordinatorYears: 0,
    sumWeeklyHoursIes: 0,
    knownWeeklyHoursCount: 0,
    averageWeeklyHoursIes: 0,
    teachersWithCoordinatorTenure: 0
  },
  ndeBody: {
    ndeMembers: 0,
    totalTeachers: 0,
    percentage: 0
  },
  teacherQualification: {
    mastersOrDoctors: 0,
    totalTeachers: 0,
    percentage: 0
  },
  teacherWorkRegime: {
    totalTeachers: 0,
    integral: 0,
    parcial: 0,
    otherKnown: 0,
    unknownRegime: 0,
    percentageIntegral: 0,
    percentageParcial: 0
  },
  teacherRegimeQualification: {
    integral: { mastersOrDoctors: 0, otherQualification: 0 },
    parcial: { mastersOrDoctors: 0, otherQualification: 0 },
    otherKnown: { mastersOrDoctors: 0, otherQualification: 0 },
    unknownRegime: { mastersOrDoctors: 0, otherQualification: 0 }
  },
  dataCoverage: {
    activeTeachersInInstitution: 0,
    terminatedCount: 0,
    classFiltersApplied: false
  },
  classStats: {
    activeClassesCount: 0,
    totalStudentsInClasses: 0,
    classesWithStudentsCount: 0,
    avgStudentsPerClass: 0
  }
};

const Regulatorio = () => {
  const { institution } = useInstitution();
  const { isConsolidatedView, selectedInstitutionId, institutions, viewMode } = useMantenedora();
  const [searchParams, setSearchParams] = useSearchParams();

  const calendarRef = useRef(null);
  const regulatoryContentRef = useRef(null);
  const { exportPdf, exportingPdf } = usePdfExport();

  const [regulatory, setRegulatory] = useState(null);
  const [noDataForFilteredPeriod, setNoDataForFilteredPeriod] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  const [knowledgeAreas, setKnowledgeAreas] = useState([]);
  const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState("");
  const [knowledgeAreasLoading, setKnowledgeAreasLoading] = useState(false);
  const [knowledgeAreasFetched, setKnowledgeAreasFetched] = useState(false);

  const [disciplines, setDisciplines] = useState([]);
  const [selectedDiscipline, setSelectedDiscipline] = useState("");
  const [disciplinesLoading, setDisciplinesLoading] = useState(false);
  const [disciplinesFetched, setdisciplinesFetched] = useState(false);

  const [courseTypes, setCourseTypes] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
  const [courseTypesLoading, setCourseTypesLoading] = useState(false);
  const [courseTypesFetched, setcourseTypesFetched] = useState(false);

  const [courseGrades, setCourseGrades] = useState([]);
  const [selectedCourseGrade, setSelectedCourseGrade] = useState("");
  const [courseGradesLoading, setCourseGradesLoading] = useState(false);
  const [courseGradesFetched, setcourseGradesFetched] = useState(false);

  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [localitiesLoading, setLocalitiesLoading] = useState(false);
  const [localitiesFetched, setlocalitiesFetched] = useState(false);

  const [modalities, setModalities] = useState([]);
  const [selectedModality, setSelectedModality] = useState("");
  const [modalitiesLoading, setModalitiesLoading] = useState(false);
  const [modalitiesFetched, setModalitiesFetched] = useState(false);

  const [shifts, setShifts] = useState([]);
  const [selectedShift, setSelectedShift] = useState("");
  const [shiftsLoading, setShiftsLoading] = useState(false);
  const [shiftsFetched, setShiftsFetched] = useState(false);

  const [showSavedFiltersModal, setShowSavedFiltersModal] = useState(false);
  const [showSaveFilterModal, setShowSaveFilterModal] = useState(false);

  const [selectedBar, setSelectedBar] = useState(null);
  const [regimeTeachers, setRegimeTeachers] = useState([]);
  const [regimeTeachersTotal, setRegimeTeachersTotal] = useState(0);
  const [regimeTeachersLoading, setRegimeTeachersLoading] = useState(false);

  const [suggestionRange, setSuggestionRange] = useState("");
  const [customMonths, setCustomMonths] = useState("24");
  const [customYears, setCustomYears] = useState("7");
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [dateRangeString, setDateRangeString] = useState("");
  const [dateRange, setDateRange] = useState(() => {
    return getDateRange() || { from: new Date(new Date().getFullYear(), 0, 1), to: new Date() };
  });

  useOutsideAlerter(calendarRef, () => setIsCalendarOpen(false));

  useEffect(() => {
    if (dateRange?.from && dateRange?.to) {
      saveDateRange(dateRange);
    }
  }, [dateRange]);

  useEffect(() => {
    if (dateRange?.from && dateRange?.to) {
      setDateRangeString(`${formatDate(dateRange.from)} - ${formatDate(dateRange.to)}`);
    }
  }, [dateRange]);

  const getEffectiveInstitutionId = useCallback(() => {
    if (isConsolidatedView) return null;
    if (selectedInstitutionId) return selectedInstitutionId;
    return institution?.id;
  }, [institution?.id, isConsolidatedView, selectedInstitutionId]);

  const aggregateRegulatory = useCallback((items) => {
    if (!items || items.length === 0) {
      return EMPTY_REGULATORY_DATA;
    }

    const validData = items.map((item) => item?.regulatoryData).filter(Boolean);
    if (validData.length === 0) {
      return EMPTY_REGULATORY_DATA;
    }

    let sumMasters = 0;
    let sumTotal = 0;
    let sumIntegral = 0;
    let sumParcial = 0;
    let sumOther = 0;
    let sumUnknown = 0;
    let sumActiveInst = 0;
    let sumTerminated = 0;
    let anyClassFilter = false;
    let sumWorkMarketYears = 0;
    let cntWorkMarketYears = 0;
    let sumHigherEducationYears = 0;
    let cntHigherEducationYears = 0;
    let sumCoordinatorYears = 0;
    let cntCoordinatorYears = 0;
    let sumWeeklyHoursIes = 0;
    let cntWeeklyHoursIes = 0;
    let sumNdeMembers = 0;
    let sumCoordTenured = 0;
    let sumRqIntMd = 0;
    let sumRqIntOth = 0;
    let sumRqParMd = 0;
    let sumRqParOth = 0;
    let sumRqOtherMd = 0;
    let sumRqOtherOth = 0;
    let sumRqUnkMd = 0;
    let sumRqUnkOth = 0;
    let sumActiveClasses = 0;
    let sumTotalStudentsInClasses = 0;
    let sumClassesWithStudents = 0;
    for (const d of validData) {
      const tq = d.teacherQualification;
      if (tq) {
        sumMasters += Number(tq.mastersOrDoctors || 0);
        sumTotal += Number(tq.totalTeachers || 0);
      }
      const tw = d.teacherWorkRegime;
      if (tw) {
        sumIntegral += Number(tw.integral || 0);
        sumParcial += Number(tw.parcial || 0);
        sumOther += Number(tw.otherKnown || 0);
        sumUnknown += Number(tw.unknownRegime || 0);
      }
      const dc = d.dataCoverage;
      if (dc) {
        sumActiveInst += Number(dc.activeTeachersInInstitution || 0);
        sumTerminated += Number(dc.terminatedCount || 0);
        if (dc.classFiltersApplied) anyClassFilter = true;
      }
      const m = d.teacherMarketExperience;
      if (m) {
        sumWorkMarketYears += Number(m.sumWorkMarketYears || 0);
        cntWorkMarketYears += Number(m.knownWorkMarketCount || 0);
      }
      const he = d.teacherHigherEducationTeaching;
      if (he) {
        sumHigherEducationYears += Number(he.sumHigherEducationYears || 0);
        cntHigherEducationYears += Number(he.knownHigherEducationCount || 0);
      }
      const cp = d.coordinatorProfile;
      if (cp) {
        sumCoordinatorYears += Number(cp.sumCoordinatorYears || 0);
        cntCoordinatorYears += Number(cp.knownCoordinatorYearsCount || 0);
        sumWeeklyHoursIes += Number(cp.sumWeeklyHoursIes || 0);
        cntWeeklyHoursIes += Number(cp.knownWeeklyHoursCount || 0);
        sumCoordTenured += Number(cp.teachersWithCoordinatorTenure || 0);
      }
      const nde = d.ndeBody;
      if (nde) {
        sumNdeMembers += Number(nde.ndeMembers || 0);
      }
      const rq = d.teacherRegimeQualification;
      if (rq) {
        sumRqIntMd += Number(rq.integral?.mastersOrDoctors || 0);
        sumRqIntOth += Number(rq.integral?.otherQualification || 0);
        sumRqParMd += Number(rq.parcial?.mastersOrDoctors || 0);
        sumRqParOth += Number(rq.parcial?.otherQualification || 0);
        sumRqOtherMd += Number(rq.otherKnown?.mastersOrDoctors || 0);
        sumRqOtherOth += Number(rq.otherKnown?.otherQualification || 0);
        sumRqUnkMd += Number(rq.unknownRegime?.mastersOrDoctors || 0);
        sumRqUnkOth += Number(rq.unknownRegime?.otherQualification || 0);
      }
      const cs = d.classStats;
      if (cs) {
        sumActiveClasses += Number(cs.activeClassesCount || 0);
        sumTotalStudentsInClasses += Number(cs.totalStudentsInClasses || 0);
        sumClassesWithStudents += Number(cs.classesWithStudentsCount || 0);
      }
    }
    const avgStudentsPerClassAgg = sumClassesWithStudents > 0
      ? Math.round((sumTotalStudentsInClasses / sumClassesWithStudents) * 10) / 10
      : 0;
    const pct = sumTotal > 0 ? Math.round((sumMasters / sumTotal) * 10000) / 100 : 0;
    const pctIntegral = sumTotal > 0 ? Math.round((sumIntegral / sumTotal) * 10000) / 100 : 0;
    const pctParcial = sumTotal > 0 ? Math.round((sumParcial / sumTotal) * 10000) / 100 : 0;
    const avgWorkM = cntWorkMarketYears > 0 ? Math.round((sumWorkMarketYears / cntWorkMarketYears) * 100) / 100 : 0;
    const avgHE = cntHigherEducationYears > 0 ? Math.round((sumHigherEducationYears / cntHigherEducationYears) * 100) / 100 : 0;
    const avgCoordY = cntCoordinatorYears > 0 ? Math.round((sumCoordinatorYears / cntCoordinatorYears) * 100) / 100 : 0;
    const avgWeekly = cntWeeklyHoursIes > 0 ? Math.round((sumWeeklyHoursIes / cntWeeklyHoursIes) * 100) / 100 : 0;
    const pctNdeAgg = sumTotal > 0 ? Math.round((sumNdeMembers / sumTotal) * 10000) / 100 : 0;

    return {
      ...EMPTY_REGULATORY_DATA,
      activeTeachers: sumTotal,
      ndeMembers: sumNdeMembers,
      averageWeeklyHoursIes: avgWeekly,
      averageHigherEducationYears: avgHE,
      teacherMarketExperience: {
        totalTeachers: sumTotal,
        sumWorkMarketYears: sumWorkMarketYears,
        knownWorkMarketCount: cntWorkMarketYears,
        averageYears: avgWorkM
      },
      teacherHigherEducationTeaching: {
        totalTeachers: sumTotal,
        sumHigherEducationYears: sumHigherEducationYears,
        knownHigherEducationCount: cntHigherEducationYears,
        averageYears: avgHE
      },
      coordinatorProfile: {
        totalTeachers: sumTotal,
        sumCoordinatorYears: sumCoordinatorYears,
        knownCoordinatorYearsCount: cntCoordinatorYears,
        averageCoordinatorYears: avgCoordY,
        sumWeeklyHoursIes: sumWeeklyHoursIes,
        knownWeeklyHoursCount: cntWeeklyHoursIes,
        averageWeeklyHoursIes: avgWeekly,
        teachersWithCoordinatorTenure: sumCoordTenured
      },
      ndeBody: {
        ndeMembers: sumNdeMembers,
        totalTeachers: sumTotal,
        percentage: pctNdeAgg
      },
      teacherQualification: {
        mastersOrDoctors: sumMasters,
        totalTeachers: sumTotal,
        percentage: pct
      },
      teacherWorkRegime: {
        totalTeachers: sumTotal,
        integral: sumIntegral,
        parcial: sumParcial,
        otherKnown: sumOther,
        unknownRegime: sumUnknown,
        percentageIntegral: pctIntegral,
        percentageParcial: pctParcial
      },
      teacherRegimeQualification: {
        integral: { mastersOrDoctors: sumRqIntMd, otherQualification: sumRqIntOth },
        parcial: { mastersOrDoctors: sumRqParMd, otherQualification: sumRqParOth },
        otherKnown: { mastersOrDoctors: sumRqOtherMd, otherQualification: sumRqOtherOth },
        unknownRegime: { mastersOrDoctors: sumRqUnkMd, otherQualification: sumRqUnkOth }
      },
      dataCoverage: {
        activeTeachersInInstitution: sumActiveInst,
        terminatedCount: sumTerminated,
        classFiltersApplied: anyClassFilter
      },
      classStats: {
        activeClassesCount: sumActiveClasses,
        totalStudentsInClasses: sumTotalStudentsInClasses,
        classesWithStudentsCount: sumClassesWithStudents,
        avgStudentsPerClass: avgStudentsPerClassAgg
      }
    };
  }, []);

  const fetchRegulatory = useCallback(
    _.debounce(
      async ({
        startDate,
        endDate,
        knowledgeArea,
        discipline,
        courseTypeId,
        courseGradeId,
        localityId,
        filtermodality,
        filtershift
      }) => {
        try {
          setLoading(true);
          setNoDataForFilteredPeriod(false);
          setSelectedBar(null);
          setRegimeTeachers([]);

          if (isConsolidatedView && institutions.length > 0) {
            const responses = await Promise.all(
              institutions.map((inst) =>
                regulatoryInstitution({
                  institutionId: inst.id,
                  startDate,
                  endDate,
                  knowledgeArea,
                  discipline,
                  courseTypeId,
                  courseGradeId,
                  localityId,
                  filtermodality,
                  filtershift
                }).catch(() => null)
              )
            );

            const allRespondedWithoutError = responses.length > 0 && responses.every((r) => r != null);
            const allNoContent = allRespondedWithoutError && responses.every((r) => r.noContent);

            if (allNoContent) {
              setRegulatory(null);
              setNoDataForFilteredPeriod(true);
            } else {
              setRegulatory(aggregateRegulatory(responses));
              setNoDataForFilteredPeriod(false);
            }
          } else {
            const institutionId = getEffectiveInstitutionId() || institution?.id;
            if (!institutionId) {
              setNoDataForFilteredPeriod(false);
              setRegulatory(EMPTY_REGULATORY_DATA);
              return;
            }

            const response = await regulatoryInstitution({
              institutionId,
              startDate,
              endDate,
              knowledgeArea,
              discipline,
              courseTypeId,
              courseGradeId,
              localityId,
              filtermodality,
              filtershift
            });

            if (response?.noContent) {
              setRegulatory(null);
              setNoDataForFilteredPeriod(true);
            } else {
              setRegulatory({ ...EMPTY_REGULATORY_DATA, ...response?.regulatoryData });
              setNoDataForFilteredPeriod(false);
            }
          }
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
          setIsCalendarOpen(false);
        }
      },
      1000
    ),
    [aggregateRegulatory, getEffectiveInstitutionId, institution?.id, institutions, isConsolidatedView]
  );

  useEffect(() => {
    const urlFilterId = searchParams.get("filterId");

    if (!urlFilterId && initialLoadComplete) {
      fetchRegulatory({
        startDate: formatDateForApiQuery(dateRange?.from),
        endDate: formatDateForApiQuery(dateRange?.to),
        knowledgeArea: selectedKnowledgeArea,
        discipline: selectedDiscipline,
        courseTypeId: selectedCourseType,
        courseGradeId: selectedCourseGrade,
        localityId: selectedLocality,
        filtermodality: selectedModality,
        filtershift: selectedShift
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLoadComplete, institution?.id]);

  useEffect(() => {
    if (initialLoadComplete) {
      fetchRegulatory({
        startDate: formatDateForApiQuery(dateRange?.from),
        endDate: formatDateForApiQuery(dateRange?.to),
        knowledgeArea: selectedKnowledgeArea,
        discipline: selectedDiscipline,
        courseTypeId: selectedCourseType,
        courseGradeId: selectedCourseGrade,
        localityId: selectedLocality,
        filtermodality: selectedModality,
        filtershift: selectedShift
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode, selectedInstitutionId]);

  useEffect(() => {
    if (!initialLoadComplete) return;

    const filtersToSave = {
      source: "Regulatorio",
      dateRange: {
        from: dateRange?.from ? dateRange.from.toISOString() : null,
        to: dateRange?.to ? dateRange.to.toISOString() : null
      },
      filters: {
        courseType: selectedCourseType || "",
        courseGrade: selectedCourseGrade || "",
        knowledgeArea: selectedKnowledgeArea || "",
        discipline: selectedDiscipline || "",
        locality: selectedLocality || "",
        modality: selectedModality || "",
        shift: selectedShift || ""
      }
    };
    saveSharedFilters(filtersToSave);
  }, [
    initialLoadComplete,
    selectedCourseType,
    selectedCourseGrade,
    selectedKnowledgeArea,
    selectedDiscipline,
    selectedLocality,
    selectedModality,
    selectedShift,
    dateRange
  ]);

  const fetchKnowledgeAreas = async () => {
    if (knowledgeAreas.length > 0) return;
    try {
      setKnowledgeAreasLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "knowledgearea"
      });

      setKnowledgeAreas(response.filterValues || []);
      setKnowledgeAreasFetched(true);
    } catch (error) {
      console.log("Erro ao buscar áreas de conhecimento", error);
    } finally {
      setKnowledgeAreasLoading(false);
    }
  };

  const fetchDisciplines = async () => {
    if (disciplines.length > 0) return;
    try {
      setDisciplinesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        predictiveFilter: "filterclass"
      });

      setDisciplines(response.filterValues || []);
      setdisciplinesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar disciplinas", error);
    } finally {
      setDisciplinesLoading(false);
    }
  };

  const fetchCourseTypes = async () => {
    if (courseTypes.length > 0) return;
    try {
      setCourseTypesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        filterClass: selectedDiscipline,
        predictiveFilter: "filterdegree"
      });

      setCourseTypes(response.filterValues || []);
      setcourseTypesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar tipos de curso", error);
    } finally {
      setCourseTypesLoading(false);
    }
  };

  const fetchCourseGrades = async () => {
    if (courseGrades.length > 0) return;
    try {
      setCourseGradesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "coursegrade"
      });

      setCourseGrades(response.filterValues || []);
      setcourseGradesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar graus de curso", error);
    } finally {
      setCourseGradesLoading(false);
    }
  };

  const fetchLocalities = async () => {
    if (localities.length > 0) return;
    try {
      setLocalitiesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        filterClass: selectedDiscipline,
        predictiveFilter: "filterlocation"
      });

      setLocalities(response.filterValues || []);
      setlocalitiesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar localidades", error);
    } finally {
      setLocalitiesLoading(false);
    }
  };

  const fetchModalities = async () => {
    if (modalities.length > 0) return;
    try {
      setModalitiesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "filtermodality"
      });

      setModalities(response.filterValues || []);
      setModalitiesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar modalidades", error);
    } finally {
      setModalitiesLoading(false);
    }
  };

  const fetchShifts = async () => {
    if (shifts.length > 0) return;
    try {
      setShiftsLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "filtershift"
      });

      setShifts(response.filterValues || []);
      setShiftsFetched(true);
    } catch (error) {
      console.log("Erro ao buscar turnos", error);
    } finally {
      setShiftsLoading(false);
    }
  };

  const REGIME_LABELS = {
    integral: "Integral",
    parcial: "Parcial",
    otherKnown: "Outro regime",
    unknownRegime: "Sem regime informado"
  };

  const QUALIFICATION_LABELS = {
    mastersOrDoctors: "Mestre ou doutor",
    otherQualification: "Demais titulações"
  };

  const handleBarClick = async ({ regime, qualification }) => {
    if (selectedBar?.regime === regime && selectedBar?.qualification === qualification) {
      setSelectedBar(null);
      setRegimeTeachers([]);
      setRegimeTeachersTotal(0);
      return;
    }

    setSelectedBar({ regime, qualification });
    setRegimeTeachersLoading(true);

    try {
      const institutionId = getEffectiveInstitutionId() || institution?.id;
      const result = await regulatoryTeachersByRegime({
        institutionId,
        regime,
        qualification,
        startDate: formatDateForApiQuery(dateRange?.from),
        endDate: formatDateForApiQuery(dateRange?.to),
        knowledgeArea: selectedKnowledgeArea,
        discipline: selectedDiscipline,
        courseTypeId: selectedCourseType,
        courseGradeId: selectedCourseGrade,
        localityId: selectedLocality,
        filtermodality: selectedModality,
        filtershift: selectedShift
      });
      setRegimeTeachers(result?.teachers || []);
      setRegimeTeachersTotal(result?.total || 0);
    } catch (e) {
      console.error(e);
      toast.error("Erro ao buscar docentes do regime selecionado.");
      setRegimeTeachers([]);
      setRegimeTeachersTotal(0);
    } finally {
      setRegimeTeachersLoading(false);
    }
  };

  const regulatoryFetchArgs = (range = dateRange, overrides = {}) => ({
    startDate: formatDateForApiQuery(range.from),
    endDate: formatDateForApiQuery(range.to),
    knowledgeArea: overrides.knowledgeArea ?? selectedKnowledgeArea,
    discipline: overrides.discipline ?? selectedDiscipline,
    courseTypeId: overrides.courseTypeId ?? selectedCourseType,
    courseGradeId: overrides.courseGradeId ?? selectedCourseGrade,
    localityId: overrides.localityId ?? selectedLocality,
    filtermodality: overrides.filtermodality ?? selectedModality,
    filtershift: overrides.filtershift ?? selectedShift
  });

  const handleKnowledgeAreaChange = (e) => {
    const newKnowledgeArea = e.target.value;

    setSelectedKnowledgeArea(newKnowledgeArea);
    setSelectedDiscipline("");
    setSelectedCourseType("");
    setSelectedCourseGrade("");
    setSelectedLocality("");
    setSelectedModality("");
    setSelectedShift("");

    setDisciplines([]);
    setCourseTypes([]);
    setCourseGrades([]);
    setLocalities([]);
    setModalities([]);
    setShifts([]);
    setdisciplinesFetched(false);
    setcourseTypesFetched(false);
    setcourseGradesFetched(false);
    setlocalitiesFetched(false);
    setModalitiesFetched(false);
    setShiftsFetched(false);

    fetchRegulatory(
      regulatoryFetchArgs(dateRange, {
        knowledgeArea: newKnowledgeArea,
        discipline: "",
        courseTypeId: "",
        courseGradeId: "",
        localityId: "",
        filtermodality: "",
        filtershift: ""
      })
    );
  };

  const handleDisciplineChange = (e) => {
    setSelectedDiscipline(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { discipline: e.target.value }));
  };

  const handleCourseTypeChange = (e) => {
    setSelectedCourseType(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { courseTypeId: e.target.value }));
  };

  const handleCourseGradeChange = (e) => {
    setSelectedCourseGrade(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { courseGradeId: e.target.value }));
  };

  const handleLocalityChange = (e) => {
    setSelectedLocality(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { localityId: e.target.value }));
  };

  const handleModalityChange = (e) => {
    setSelectedModality(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { filtermodality: e.target.value }));
  };

  const handleShiftChange = (e) => {
    setSelectedShift(e.target.value);
    fetchRegulatory(regulatoryFetchArgs(dateRange, { filtershift: e.target.value }));
  };

  useEffect(() => {
    const urlFilterId = searchParams.get("filterId");

    if (urlFilterId && institution?.id && !initialLoadComplete) {
      const fetchFilterById = async () => {
        try {
          const savedFilter = await getSavedFilterById({
            institutionId: institution.id,
            filterId: urlFilterId
          });

          const filterData =
            typeof savedFilter.filterJson === "string" ? JSON.parse(savedFilter.filterJson) : savedFilter.filterJson;

          let fetchStartDate = formatDateForApiQuery(dateRange.from);
          let fetchEndDate = formatDateForApiQuery(dateRange.to);

          if (filterData.dateRange) {
            const newDateRange = {};

            if (filterData.dateRange.startDate) {
              const [day, month, year] = filterData.dateRange.startDate.split("-");
              newDateRange.from = new Date(year, month - 1, day);
              fetchStartDate = filterData.dateRange.startDate;
            }

            if (filterData.dateRange.endDate) {
              const [day, month, year] = filterData.dateRange.endDate.split("-");
              newDateRange.to = new Date(year, month - 1, day);
              fetchEndDate = filterData.dateRange.endDate;
            }

            if (newDateRange.from || newDateRange.to) {
              setDateRange((prev) => ({
                from: newDateRange.from || prev.from,
                to: newDateRange.to || prev.to
              }));
            }
          }

          if (knowledgeAreas.length === 0) await fetchKnowledgeAreas();
          if (courseTypes.length === 0) await fetchCourseTypes();
          if (modalities.length === 0) await fetchModalities();
          if (shifts.length === 0) await fetchShifts();
          if (filterData.filters?.knowledgeArea && disciplines.length === 0) await fetchDisciplines();
          if (filterData.filters?.discipline && localities.length === 0) await fetchLocalities();
          if (filterData.filters?.courseGrade && courseGrades.length === 0) await fetchCourseGrades();

          if (filterData.filters) {
            setSelectedCourseType(filterData.filters.courseType || "");
            setSelectedCourseGrade(filterData.filters.courseGrade || "");
            setSelectedKnowledgeArea(filterData.filters.knowledgeArea || "");
            setSelectedDiscipline(filterData.filters.discipline || "");
            setSelectedLocality(filterData.filters.locality || "");
            setSelectedModality(filterData.filters.modality || "");
            setSelectedShift(filterData.filters.shift || "");
          }

          await fetchRegulatory({
            startDate: fetchStartDate,
            endDate: fetchEndDate,
            knowledgeArea: filterData.filters?.knowledgeArea || "",
            discipline: filterData.filters?.discipline || "",
            courseTypeId: filterData.filters?.courseType || "",
            courseGradeId: filterData.filters?.courseGrade || "",
            localityId: filterData.filters?.locality || "",
            filtermodality: filterData.filters?.modality || "",
            filtershift: filterData.filters?.shift || ""
          });

          toast.success(`Filtro "${savedFilter.name}" aplicado automaticamente!`);
          setInitialLoadComplete(true);
        } catch (error) {
          console.error("Erro ao buscar filtro por ID:", error);
          toast.error("Erro ao carregar filtro da URL");
          setInitialLoadComplete(true);
          setLoading(false);
        }
      };

      fetchFilterById();
    } else if (!urlFilterId && !initialLoadComplete) {
      const sharedFilters = getSharedFilters();

      if (sharedFilters?.source === "Regulatorio" && institution?.id) {
        const restoreSharedFilters = async () => {
          try {
            if (sharedFilters.dateRange) {
              const newDateRange = {};

              if (sharedFilters.dateRange.from) {
                newDateRange.from = new Date(sharedFilters.dateRange.from);
              }

              if (sharedFilters.dateRange.to) {
                newDateRange.to = new Date(sharedFilters.dateRange.to);
              }

              if (newDateRange.from || newDateRange.to) {
                setDateRange((prev) => ({
                  from: newDateRange.from || prev.from,
                  to: newDateRange.to || prev.to
                }));
              }
            }

            if (sharedFilters.filters?.knowledgeArea && knowledgeAreas.length === 0) await fetchKnowledgeAreas();
            if (sharedFilters.filters?.courseType && courseTypes.length === 0) await fetchCourseTypes();
            if (sharedFilters.filters?.modality && modalities.length === 0) await fetchModalities();
            if (sharedFilters.filters?.shift && shifts.length === 0) await fetchShifts();
            if (sharedFilters.filters?.discipline && disciplines.length === 0) await fetchDisciplines();
            if (sharedFilters.filters?.locality && localities.length === 0) await fetchLocalities();
            if (sharedFilters.filters?.courseGrade && courseGrades.length === 0) await fetchCourseGrades();

            if (sharedFilters.filters) {
              setSelectedCourseType(sharedFilters.filters.courseType || "");
              setSelectedCourseGrade(sharedFilters.filters.courseGrade || "");
              setSelectedKnowledgeArea(sharedFilters.filters.knowledgeArea || "");
              setSelectedDiscipline(sharedFilters.filters.discipline || "");
              setSelectedLocality(sharedFilters.filters.locality || "");
              setSelectedModality(sharedFilters.filters.modality || "");
              setSelectedShift(sharedFilters.filters.shift || "");
            }

            const fetchStartDate = sharedFilters.dateRange?.from
              ? formatDateForApiQuery(new Date(sharedFilters.dateRange.from))
              : formatDateForApiQuery(dateRange.from);
            const fetchEndDate = sharedFilters.dateRange?.to
              ? formatDateForApiQuery(new Date(sharedFilters.dateRange.to))
              : formatDateForApiQuery(dateRange.to);

            await fetchRegulatory({
              startDate: fetchStartDate,
              endDate: fetchEndDate,
              knowledgeArea: sharedFilters.filters?.knowledgeArea || "",
              discipline: sharedFilters.filters?.discipline || "",
              courseTypeId: sharedFilters.filters?.courseType || "",
              courseGradeId: sharedFilters.filters?.courseGrade || "",
              localityId: sharedFilters.filters?.locality || "",
              filtermodality: sharedFilters.filters?.modality || "",
              filtershift: sharedFilters.filters?.shift || ""
            });

            setInitialLoadComplete(true);
          } catch (error) {
            console.error("Erro ao restaurar filtros do localStorage:", error);
            setInitialLoadComplete(true);
          }
        };

        restoreSharedFilters();
      } else if (sharedFilters?.source !== "Regulatorio" || institution?.id) {
        setInitialLoadComplete(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, institution?.id, initialLoadComplete]);

  const convertFiltersToApiFormat = () => {
    const hasActiveFilters =
      selectedCourseType ||
      selectedCourseGrade ||
      selectedKnowledgeArea ||
      selectedDiscipline ||
      selectedLocality ||
      selectedModality ||
      selectedShift;

    if (!hasActiveFilters && !dateRange?.from && !dateRange?.to) {
      return null;
    }

    return {
      source: "Regulatorio",
      dateRange: {
        startDate: dateRange?.from ? formatDateForApiQuery(dateRange.from) : null,
        endDate: dateRange?.to ? formatDateForApiQuery(dateRange.to) : null
      },
      filters: {
        courseType: selectedCourseType || "",
        courseGrade: selectedCourseGrade || "",
        knowledgeArea: selectedKnowledgeArea || "",
        discipline: selectedDiscipline || "",
        locality: selectedLocality || "",
        modality: selectedModality || "",
        shift: selectedShift || ""
      }
    };
  };

  const convertApiFilterToLocal = useCallback((savedFilter) => {
    try {
      let filterData;
      if (typeof savedFilter.filterJson === "string") {
        filterData = JSON.parse(savedFilter.filterJson);
      } else {
        filterData = savedFilter.filterJson;
      }

      if (!filterData) return;

      if (filterData.dateRange) {
        const newDateRange = {};

        if (filterData.dateRange.startDate) {
          const [day, month, year] = filterData.dateRange.startDate.split("-");
          newDateRange.from = new Date(year, month - 1, day);
        }

        if (filterData.dateRange.endDate) {
          const [day, month, year] = filterData.dateRange.endDate.split("-");
          newDateRange.to = new Date(year, month - 1, day);
        }

        if (newDateRange.from || newDateRange.to) {
          setDateRange((prev) => ({
            from: newDateRange.from || prev.from,
            to: newDateRange.to || prev.to
          }));
        }
      }

      if (filterData.filters) {
        setSelectedCourseType(filterData.filters.courseType || "");
        setSelectedCourseGrade(filterData.filters.courseGrade || "");
        setSelectedKnowledgeArea(filterData.filters.knowledgeArea || "");
        setSelectedDiscipline(filterData.filters.discipline || "");
        setSelectedLocality(filterData.filters.locality || "");
        setSelectedModality(filterData.filters.modality || "");
        setSelectedShift(filterData.filters.shift || "");
      }
    } catch (error) {
      console.error("Erro ao converter filtro salvo:", error);
      toast.error("Erro ao processar filtro salvo");
    }
  }, []);

  const handleOpenSavedFilters = () => {
    setShowSavedFiltersModal(true);
  };

  const handleOpenSaveFilter = () => {
    const filterData = convertFiltersToApiFormat();

    if (!filterData) {
      toast.warning("Adicione pelo menos um filtro ou selecione um período antes de salvar");
      return;
    }

    setShowSaveFilterModal(true);
  };

  const updateURLWithFilterId = (filterId) => {
    const params = new URLSearchParams();
    if (filterId) {
      params.set("filterId", filterId);
    }
    setSearchParams(params);
  };

  const handleApplySavedFilter = async (savedFilter) => {
    updateURLWithFilterId(savedFilter.id);

    const filterData =
      typeof savedFilter.filterJson === "string" ? JSON.parse(savedFilter.filterJson) : savedFilter.filterJson;

    convertApiFilterToLocal(savedFilter);

    if (filterData.filters?.knowledgeArea && knowledgeAreas.length === 0) await fetchKnowledgeAreas();
    if (filterData.filters?.discipline && disciplines.length === 0) await fetchDisciplines();
    if (filterData.filters?.courseType && courseTypes.length === 0) await fetchCourseTypes();
    if (filterData.filters?.courseGrade && courseGrades.length === 0) await fetchCourseGrades();
    if (filterData.filters?.locality && localities.length === 0) await fetchLocalities();
    if (filterData.filters?.modality && modalities.length === 0) await fetchModalities();
    if (filterData.filters?.shift && shifts.length === 0) await fetchShifts();

    setTimeout(() => {
      const startDate =
        filterData.dateRange?.startDate || formatDateForApiQuery(dateRange.from);
      const endDate = filterData.dateRange?.endDate || formatDateForApiQuery(dateRange.to);

      fetchRegulatory({
        startDate,
        endDate,
        knowledgeArea: filterData.filters?.knowledgeArea || "",
        discipline: filterData.filters?.discipline || "",
        courseTypeId: filterData.filters?.courseType || "",
        courseGradeId: filterData.filters?.courseGrade || "",
        localityId: filterData.filters?.locality || "",
        filtermodality: filterData.filters?.modality || "",
        filtershift: filterData.filters?.shift || ""
      });

      toast.success(`Filtro "${savedFilter.name}" aplicado com sucesso!`);
    }, 100);
  };

  const handleClearFilters = () => {
    setSelectedKnowledgeArea("");
    setSelectedDiscipline("");
    setSelectedCourseType("");
    setSelectedCourseGrade("");
    setSelectedLocality("");
    setSelectedModality("");
    setSelectedShift("");

    setDisciplines([]);
    setCourseGrades([]);
    setLocalities([]);

    setdisciplinesFetched(false);
    setcourseTypesFetched(false);
    setcourseGradesFetched(false);
    setlocalitiesFetched(false);
    setModalitiesFetched(false);
    setShiftsFetched(false);

    setSearchParams(new URLSearchParams());
    clearSharedFilters();

    fetchRegulatory({
      startDate: formatDateForApiQuery(dateRange.from),
      endDate: formatDateForApiQuery(dateRange.to),
      knowledgeArea: "",
      discipline: "",
      courseTypeId: "",
      courseGradeId: "",
      localityId: "",
      filtermodality: "",
      filtershift: ""
    });

    toast.success("Filtros limpos com sucesso!");
  };

  const selectManualRange = () => {
    setSuggestionRange("");
    fetchRegulatory(regulatoryFetchArgs(dateRange));
  };

  const selectSuggestionRange = (selectedSuggestionRange) => {
    setSuggestionRange(selectedSuggestionRange);
    const currentYear = new Date().getFullYear();
    let selectedRange;

    switch (selectedSuggestionRange) {
      case "today":
        selectedRange = { from: new Date(), to: new Date() };
        break;
      case "last_7":
        selectedRange = { from: new Date(new Date().setDate(new Date().getDate() - 7)), to: new Date() };
        break;
      case "last_30": {
        const now = new Date();
        selectedRange = {
          from: new Date(now.getFullYear(), now.getMonth(), 1),
          to: new Date(now.getFullYear(), now.getMonth() + 1, 0)
        };
        break;
      }
      case "first_semester":
        selectedRange = {
          from: new Date(`${currentYear}-01-01T00:00:00`),
          to: new Date(`${currentYear}-06-30T23:59:59`)
        };
        break;
      case "second_semester":
        selectedRange = {
          from: new Date(`${currentYear}-07-01T00:00:00`),
          to: new Date(`${currentYear}-12-31T23:59:59`)
        };
        break;
      case "last_semester": {
        const today = new Date();
        const isSecondSemester = today.getMonth() >= 6;
        if (isSecondSemester) {
          selectedRange = {
            from: new Date(`${currentYear}-01-01T00:00:00`),
            to: new Date(`${currentYear}-06-30T23:59:59`)
          };
        } else {
          const lastYear = currentYear - 1;
          selectedRange = {
            from: new Date(`${lastYear}-07-01T00:00:00`),
            to: new Date(`${lastYear}-12-31T23:59:59`)
          };
        }
        break;
      }
      case "last_year": {
        // Janela movel: mesmo dia ha 12 meses ate hoje (inclusive). O intervalo antigo
        // (1o dia do mes / ultimo dia do mes anterior) excluia o mes corrente e confundia com "ultimos 12 meses".
        const to = new Date();
        const from = new Date(to.getTime());
        from.setFullYear(from.getFullYear() - 1);
        selectedRange = { from, to };
        break;
      }
      case "last_x_months": {
        const monthsBack = parseInt(customMonths, 10);
        if (Number.isNaN(monthsBack) || monthsBack <= 0) return;
        const now = new Date();
        selectedRange = {
          from: new Date(now.getFullYear(), now.getMonth() - monthsBack, now.getDate()),
          to: new Date()
        };
        break;
      }
      case "current_year":
        selectedRange = {
          from: new Date(currentYear, 0, 1),
          to: new Date()
        };
        break;
      case "previous_year": {
        const previousYear = currentYear - 1;
        selectedRange = {
          from: new Date(`${previousYear}-01-01T00:00:00`),
          to: new Date(`${previousYear}-12-31T23:59:59`)
        };
        break;
      }
      case "last_5_years":
        selectedRange = {
          from: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
          to: new Date()
        };
        break;
      case "last_x_years": {
        const yearsBack = parseInt(customYears, 10);
        if (Number.isNaN(yearsBack) || yearsBack <= 0) return;
        const startYear = currentYear - yearsBack;
        selectedRange = {
          from: new Date(`${startYear}-01-01T00:00:00`),
          to: new Date(`${currentYear - 1}-12-31T23:59:59`)
        };
        break;
      }
      default:
        selectedRange = {
          from: new Date(new Date().setMonth(new Date().getMonth() - 3)),
          to: new Date()
        };
        break;
    }

    setDateRange(selectedRange);
    setDateRangeString(`${formatDate(selectedRange.from)} - ${formatDate(selectedRange.to)}`);
    fetchRegulatory(regulatoryFetchArgs(selectedRange));
  };

  const handleClearSelection = () => {
    setSuggestionRange("");
    setDateRange({ from: new Date(), to: new Date() });
  };

  const handleExportPDF = async () => {
    if (!regulatory) {
      toast.warning("Sem dados para exportar");
      return;
    }

    const getLabel = (options, value) => {
      if (!value) return null;
      const opt = options.find((o) => String(o.id ?? o) === String(value));
      return opt ? (opt.name ?? String(opt)) : value;
    };

    const activeFilters = [
      { label: "Período", value: dateRangeString },
      { label: "Tipo de Curso", value: getLabel(courseTypes, selectedCourseType) },
      { label: "Área de Conhecimento", value: getLabel(knowledgeAreas, selectedKnowledgeArea) },
      { label: "Curso", value: getLabel(disciplines, selectedDiscipline) },
      { label: "Grau", value: getLabel(courseGrades, selectedCourseGrade) },
      { label: "Localidade", value: getLabel(localities, selectedLocality) },
      { label: "Modalidade", value: getLabel(modalities, selectedModality) },
      { label: "Turno", value: getLabel(shifts, selectedShift) },
    ].filter((f) => f.value);

    const from = formatDate(dateRange?.from).replaceAll("/", "-");
    const to = formatDate(dateRange?.to).replaceAll("/", "-");

    try {
      await exportPdf([regulatoryContentRef], {
        title: "Relatório Regulatório",
        filename: `regulatorio-${from}_${to}.pdf`,
        logoUrl: logoLoginImg,
        filters: activeFilters,
      });
      toast.success("PDF exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar PDF. Tente novamente.");
    }
  };

  const thStyle = {
    padding: "8px 12px",
    textAlign: "left",
    fontWeight: 600,
    color: "#555",
    whiteSpace: "nowrap"
  };

  const tdStyle = {
    padding: "7px 12px",
    color: "#333",
    whiteSpace: "nowrap"
  };

  const teacherQualificationPercentage = Number(regulatory?.teacherQualification?.percentage || 0);
  const totalTeachers = Number(regulatory?.teacherQualification?.totalTeachers || 0);

  const twr = regulatory?.teacherWorkRegime;
  const pctIntegral = Number(twr?.percentageIntegral || 0);
  const pctParcial = Number(twr?.percentageParcial || 0);

  const fmtDec1 = (v) =>
    Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  const tme = regulatory?.teacherMarketExperience;
  const the = regulatory?.teacherHigherEducationTeaching;
  const coord = regulatory?.coordinatorProfile;
  const nde = regulatory?.ndeBody;

  const dc = regulatory?.dataCoverage;
  const showDataCoverageHint = Boolean(regulatory && totalTeachers === 0 && dc);

  const dataCoverageMessage = (() => {
    if (!showDataCoverageHint || !dc) return "";
    const active = Number(dc.activeTeachersInInstitution || 0);
    const terminated = Number(dc.terminatedCount || 0);
    const classF = Boolean(dc.classFiltersApplied);
    if (active === 0) {
      return "Nao ha docentes ativos nesta instituicao no cadastro de docentes.";
    }
    const parts = [
      "Os indicadores usam apenas docentes sem data de termino (vinculo vigente).",
      `Nesta instituicao ha ${active} docente(s) no cadastro.`,
      terminated > 0 ? `${terminated} com data de termino preenchida (desligados).` : null,
      classF
        ? "Filtros de turma estao ativos: entram somente docentes vinculados a turmas que passam nos filtros."
        : null
    ].filter(Boolean);
    return parts.join(" ");
  })();

  return (
    <div>
      <HeaderTitle title="Regulatorio" icon={RegulatoryIcon} />

      <div className={styles.filterWrapper}>
        <div className={styles.filterContainer}>
          <FilterSelect
            icon={CourseIcon}
            label="Tipo de Curso"
            value={selectedCourseType}
            loading={courseTypesLoading}
            options={courseTypes}
            onFocus={fetchCourseTypes}
            hasFetched={courseTypesFetched}
            onChange={handleCourseTypeChange}
          />
          <FilterSelect
            icon={BookIcon}
            label="Área de Conhecimento"
            value={selectedKnowledgeArea}
            loading={knowledgeAreasLoading}
            options={knowledgeAreas}
            onFocus={fetchKnowledgeAreas}
            hasFetched={knowledgeAreasFetched}
            onChange={handleKnowledgeAreaChange}
          />
          <FilterSelect
            icon={DiscIcon}
            label="Curso"
            value={selectedDiscipline}
            loading={disciplinesLoading}
            options={disciplines}
            onFocus={fetchDisciplines}
            hasFetched={disciplinesFetched}
            onChange={handleDisciplineChange}
          />
          <FilterSelect
            icon={CourseIcon}
            label="Grau"
            value={selectedCourseGrade}
            loading={courseGradesLoading}
            options={courseGrades}
            onFocus={fetchCourseGrades}
            hasFetched={courseGradesFetched}
            onChange={handleCourseGradeChange}
          />
          <FilterSelect
            icon={LocaleIcon}
            label="Localidade"
            value={selectedLocality}
            loading={localitiesLoading}
            options={localities}
            onFocus={fetchLocalities}
            hasFetched={localitiesFetched}
            onChange={handleLocalityChange}
          />
          <FilterSelect
            icon={ClassesIcon}
            label="Modalidade"
            value={selectedModality}
            loading={modalitiesLoading}
            options={modalities}
            onFocus={fetchModalities}
            hasFetched={modalitiesFetched}
            onChange={handleModalityChange}
          />
          <FilterSelect
            icon={CalendarDayIcon}
            label="Turno"
            value={selectedShift}
            loading={shiftsLoading}
            options={shifts}
            onFocus={fetchShifts}
            hasFetched={shiftsFetched}
            onChange={handleShiftChange}
          />
        </div>

        <div className={styles.headerTitleActions}>
          <Button
            icon={BarsFilterIcon}
            text="Filtros Salvos"
            size="normal"
            variation="outline"
            onClick={handleOpenSavedFilters}
          />

          <Button
            icon={FileExportIcon}
            text="Exportar PDF"
            size="normal"
            variation="outline"
            loading={exportingPdf}
            disabled={!regulatory}
            onClick={handleExportPDF}
          />

          <Button
            icon={BarsFilterIcon}
            text="Salvar Filtro"
            size="normal"
            variation="primary"
            onClick={handleOpenSaveFilter}
          />

          <Button
            icon={BarsFilterIcon}
            text="Limpar Filtros"
            size="normal"
            variation="secondary"
            onClick={handleClearFilters}
          />

          <div className={`${styles.headerTitleActionsCalendar} .finance-calendar`}>
            <Button
              icon={CalendarIcon}
              text={dateRangeString}
              size="normal"
              variation="outline"
              onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            />

            {isCalendarOpen && (
              <div ref={calendarRef} className={styles.calenderContent}>
                <div className={styles.suggestions}>
                  <ul>
                    {[
                      { key: "today", label: "Hoje" },
                      { key: "last_7", label: "Ultimos 7 dias" },
                      { key: "last_30", label: "Ultimo mes" },
                      { key: "first_semester", label: "Primeiro Semestre" },
                      { key: "second_semester", label: "Segundo Semestre" },
                      { key: "last_semester", label: "Ultimo Semestre" },
                      { key: "last_year", label: "Ultimos 12 meses" }
                    ].map((item) => (
                      <li
                        key={item.key}
                        onClick={() => !loading && selectSuggestionRange(item.key)}
                        className={clsx(styles.suggestionsItem, {
                          [styles.active]: suggestionRange === item.key
                        })}
                        style={{ opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                      >
                        {item.label}
                      </li>
                    ))}

                    <li
                      className={clsx(styles.suggestionsItem, styles.customMonthsItem, {
                        [styles.active]: suggestionRange === "last_x_months"
                      })}
                      style={{ opacity: loading ? 0.6 : 1 }}
                    >
                      <span>Ultimos</span>
                      <input
                        type="number"
                        min="1"
                        className={styles.customMonthsInput}
                        value={customMonths}
                        onChange={(e) => setCustomMonths(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !loading && customMonths) {
                            selectSuggestionRange("last_x_months");
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        disabled={loading}
                      />
                      <span
                        style={{ cursor: loading || !customMonths ? "default" : "pointer" }}
                        onClick={() => !loading && customMonths && selectSuggestionRange("last_x_months")}
                      >
                        meses
                      </span>
                    </li>

                    {[
                      { key: "current_year", label: "Ano Atual" },
                      { key: "previous_year", label: "Ano Anterior" },
                      { key: "last_5_years", label: "Ultimos 5 Anos" }
                    ].map((item) => (
                      <li
                        key={item.key}
                        onClick={() => !loading && selectSuggestionRange(item.key)}
                        className={clsx(styles.suggestionsItem, {
                          [styles.active]: suggestionRange === item.key
                        })}
                        style={{ opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                      >
                        {item.label}
                      </li>
                    ))}

                    <li
                      className={clsx(styles.suggestionsItem, styles.customMonthsItem, {
                        [styles.active]: suggestionRange === "last_x_years"
                      })}
                      style={{ opacity: loading ? 0.6 : 1 }}
                    >
                      <span>Ultimos</span>
                      <input
                        type="number"
                        min="1"
                        className={styles.customMonthsInput}
                        value={customYears}
                        onChange={(e) => setCustomYears(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !loading && customYears) {
                            selectSuggestionRange("last_x_years");
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        disabled={loading}
                      />
                      <span
                        style={{ cursor: loading || !customYears ? "default" : "pointer" }}
                        onClick={() => !loading && customYears && selectSuggestionRange("last_x_years")}
                      >
                        anos
                      </span>
                    </li>

                    <li
                      onClick={() => !loading && setSuggestionRange("manual")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "manual"
                      })}
                    >
                      Personalizado
                    </li>
                  </ul>

                  <div>
                    <div
                      onClick={() => !loading && handleClearSelection()}
                      className={clsx(styles.suggestionsItem, styles.active)}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                    >
                      Limpar selecao
                    </div>

                    <div
                      onClick={() => !loading && selectManualRange()}
                      className={clsx(styles.suggestionsItem, styles.active, styles["btn-search-data"])}
                      style={{ opacity: loading ? 0.8 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                    >
                      {loading ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img src={loadingGif} alt="Carregando..." style={{ width: "16px", height: "16px" }} />
                          <span>Carregando...</span>
                        </div>
                      ) : (
                        <>
                          <img src={BarsFilterIcon} alt="filtrar" />
                          Buscar dados
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.dateRangeGroup}>
                  <div className={styles.datePickerWrapper}>
                    <label>Data de Inicio</label>
                    <DayPicker
                      mode="single"
                      selected={dateRange?.from}
                      defaultMonth={dateRange?.from}
                      onSelect={(from) => setDateRange((prev) => ({ ...prev, from }))}
                      locale={ptBR}
                      captionLayout="dropdown"
                    />
                  </div>

                  <div className={styles.datePickerWrapper}>
                    <label>Data de Fim</label>
                    <DayPicker
                      mode="single"
                      selected={dateRange?.to}
                      defaultMonth={dateRange?.to}
                      onSelect={(to) => setDateRange((prev) => ({ ...prev, to }))}
                      locale={ptBR}
                      captionLayout="dropdown"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div ref={regulatoryContentRef} className={`${styles.financeContent} .finance-content`}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
            <img src={loadingGif} alt="Carregando..." style={{ width: "60px", height: "60px" }} />
          </div>
        ) : noDataForFilteredPeriod ? (
          <ZeroData>
            <div>
              <h3>Nenhum docente ativo (sem data de término) para os filtros aplicados.</h3>
            </div>
          </ZeroData>
        ) : !regulatory ? (
          <ZeroData>
            <h4>Nao foi possivel carregar os indicadores regulatorios.</h4>
          </ZeroData>
        ) : (
          <>
            {/* 9 cards: 3 colunas fecham 3x3 sem buraco no fim (grid_5 de 2 colunas deixava um vao) */}
            <div className={styles.grid_2}>
              <FinanceCard
                title="Titulacao do corpo docente (% mestres e doutores)"
                value={addPorcentage(teacherQualificationPercentage)}
                icon={ChartMixedPorcentageIcon}
                explanation="Percentual de docentes com titulacao mestre ou doutor entre os docentes ativos (sem data de termino)."
                code="R-01"
              />
              <FinanceCard
                title="Regime integral (% sobre docentes ativos)"
                value={addPorcentage(pctIntegral)}
                icon={ChartUserCheckIcon}
                explanation="Docentes classificados como tempo integral conforme o regime de trabalho informado no cadastro, na mesma base de titulacao (docentes ativos)."
                code="R-02"
              />
              <FinanceCard
                title="Regime parcial (% sobre docentes ativos)"
                value={addPorcentage(pctParcial)}
                icon={ChartUserSearchIcon}
                explanation="Docentes classificados como tempo parcial conforme o regime de trabalho informado no cadastro, na mesma base (docentes ativos)."
                code="R-03"
              />
              <FinanceCard
                title="Experiencia profissional — mercado (anos)"
                value={`${fmtDec1(tme?.averageYears)} anos`}
                icon={ChartMoneyIcon}
                explanation="Media de anos de experiencia no mercado de trabalho entre docentes com o dado informado no cadastro; considera apenas docentes ativos (sem data de termino)."
                code="R-04"
              />
              <FinanceCard
                title="Experiencia de magisterio superior (anos)"
                value={`${fmtDec1(the?.averageYears)} anos`}
                icon={ChartCourseUpIcon}
                explanation="Media de anos de magisterio superior entre docentes com o dado informado no cadastro; considera apenas docentes ativos (sem data de termino)."
                code="R-05"
              />
              <FinanceCard
                title="Atuacao do coordenador (anos / dedicacao)"
                value={`${fmtDec1(coord?.averageCoordinatorYears)} anos`}
                icon={UserIcon}
                explanation="Media de anos de atuacao como coordenador e media de carga horaria semanal na instituicao, entre docentes com os respectivos dados informados no cadastro; considera apenas docentes ativos (sem data de termino)."
                code="R-06"
              />
              <FinanceCard
                title="NDE — integrantes do corpo docente"
                value={addPorcentage(Number(nde?.percentage || 0))}
                icon={ChartUserShieldIcon}
                explanation="Percentual de docentes marcados como integrantes do NDE no cadastro, na base de docentes ativos (sem data de termino)."
                code="R-07"
              />
              <FinanceCard
                title="Turmas ativas no periodo"
                value={String(Number(regulatory?.classStats?.activeClassesCount || 0))}
                icon={ClassesIcon}
                explanation="Quantidade de turmas com registro ativo cuja vigencia se sobrepos ao periodo filtrado."
                code="R-09"
              />
              <FinanceCard
                title="Media de alunos por turma"
                value={fmtDec1(regulatory?.classStats?.avgStudentsPerClass)}
                icon={UsersIcon}
                explanation="Media de alunos distintos por turma, calculada sobre as turmas vigentes no periodo com alunos registrados no academico."
                code="R-10"
              />
            </div>
            <div className={styles.grid_1} style={{ marginTop: "16px" }}>
              <TeacherRegimeQualificationChart
                teacherRegimeQualification={regulatory?.teacherRegimeQualification}
                code="R-08"
                onBarClick={!isConsolidatedView ? handleBarClick : undefined}
                selectedBar={selectedBar}
              />
            </div>
            {selectedBar && (
              <div className={styles.grid_1} style={{ marginTop: "16px" }}>
                <div style={{ background: "#fff", padding: "20px", borderRadius: "4px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                    <div>
                      <h4 style={{ margin: 0, fontSize: "14px", color: "var(--primary-color)" }}>
                        Docentes: {REGIME_LABELS[selectedBar.regime]} — {QUALIFICATION_LABELS[selectedBar.qualification]}
                      </h4>
                      {!regimeTeachersLoading && (
                        <span style={{ fontSize: "12px", color: "#858585" }}>
                          {regimeTeachersTotal} docente(s) encontrado(s)
                          {regimeTeachersTotal > 200 ? " — exibindo os primeiros 200" : ""}
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => { setSelectedBar(null); setRegimeTeachers([]); setRegimeTeachersTotal(0); }}
                      style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#858585", lineHeight: 1 }}
                      title="Fechar lista"
                    >
                      ×
                    </button>
                  </div>
                  {regimeTeachersLoading && regimeTeachers.length === 0 ? (
                    <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
                      <img src={loadingGif} alt="Carregando..." style={{ width: "40px", height: "40px" }} />
                    </div>
                  ) : !regimeTeachersLoading && regimeTeachers.length === 0 ? (
                    <p style={{ color: "#858585", fontSize: "14px", margin: 0 }}>Nenhum docente encontrado para esta seleção.</p>
                  ) : (
                    <div style={{ position: "relative" }}>
                      <div style={{ overflowX: "auto", opacity: regimeTeachersLoading ? 0.35 : 1, transition: "opacity 0.15s ease" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                          <thead>
                            <tr style={{ background: "#f5f7fa" }}>
                              <th style={thStyle}>ID Docente</th>
                              <th style={thStyle}>Titulação</th>
                              <th style={thStyle}>Regime</th>
                              <th style={thStyle}>Data de Ingresso</th>
                              <th style={thStyle}>UF</th>
                              <th style={thStyle}>Cidade</th>
                              <th style={{ ...thStyle, textAlign: "right" }}>Exp. Mercado (anos)</th>
                              <th style={{ ...thStyle, textAlign: "right" }}>Exp. ES (anos)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {regimeTeachers.map((t, idx) => (
                              <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                <td style={tdStyle}>{t.teacherId || "—"}</td>
                                <td style={tdStyle}>{t.maxDegree || "—"}</td>
                                <td style={tdStyle}>{t.workRegime || "—"}</td>
                                <td style={tdStyle}>{t.entryDate ? new Date(t.entryDate + "T00:00:00").toLocaleDateString("pt-BR") : "—"}</td>
                                <td style={tdStyle}>{t.state || "—"}</td>
                                <td style={tdStyle}>{t.city || "—"}</td>
                                <td style={{ ...tdStyle, textAlign: "right" }}>{t.workMarketYears ?? "—"}</td>
                                <td style={{ ...tdStyle, textAlign: "right" }}>{t.higherEducationYears ?? "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {regimeTeachersLoading && (
                        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <img src={loadingGif} alt="Carregando..." style={{ width: "32px", height: "32px" }} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
            {showDataCoverageHint && dataCoverageMessage ? (
              <div className={styles.grid_1} style={{ marginTop: "12px" }}>
                <p style={{ color: "#555", fontSize: "14px", margin: 0, lineHeight: 1.5 }}>{dataCoverageMessage}</p>
              </div>
            ) : null}
          </>
        )}
      </div>

      {showSavedFiltersModal && (
        <SavedFiltersModal
          onClose={() => setShowSavedFiltersModal(false)}
          onApplyFilter={handleApplySavedFilter}
          filterSource="Regulatorio"
          onCreateFilter={handleOpenSaveFilter}
        />
      )}

      {showSaveFilterModal && (
        <SaveFilterModal
          onClose={() => setShowSaveFilterModal(false)}
          onFilterSaved={() => {
            toast.success("Filtro salvo com sucesso!");
            setShowSaveFilterModal(false);
          }}
          filterData={convertFiltersToApiFormat()}
        />
      )}
    </div>
  );
};

export default Regulatorio;
